import { CaretDownIcon, CheckIcon } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';

interface SelectProps {
  label?: string;
  name?: string;
  options: { value: string; label: string; icon?: React.ReactNode }[];
  className?: string;
  onChange?: (selectedValues: string[]) => void;
  value?: string[];
  error?: string;
  viewerType?: string;
  icon?: React.ReactNode;
  placeholder?: string;
}

export default function MultiFilterSelect({
  label,
  options,
  className,
  onChange,
  value = [],
  error,
  placeholder = 'Filter',
}: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(
    options.filter(option => value.includes(option.value))
  );

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: {
    value: string;
    label: string;
    icon?: React.ReactNode;
  }) => {
    const isSelected = selectedOptions.some(
      selected => selected.value === option.value
    );
    let newSelectedOptions;

    if (isSelected) {
      newSelectedOptions = selectedOptions.filter(
        selected => selected.value !== option.value
      );
    } else {
      newSelectedOptions = [...selectedOptions, option];
    }

    setSelectedOptions(newSelectedOptions);
    onChange?.(newSelectedOptions.map(opt => opt.value));
  };

  useEffect(() => {
    const newSelected = options.filter(option => value.includes(option.value));
    setSelectedOptions(newSelected);
  }, [value, options]);

  return (
    <div className={`relative inline-block ${className}`}>
      <label>{label}</label>
      <div
        onClick={toggleDropdown}
        className='flex justify-between items-center h-[40px] gap-2 px-4 py-2 mt-2 bg-transparent border border-[#9D9898] rounded-full cursor-pointer shadow-sm hover:shadow-md'
      >
        <section className='flex gap-2 items-center'>
          {/* <Icon name={icon} className="w-4 h-4" /> */}
          <span className='text-sm text-[#1D2939] capitalize font-medium'>
            {selectedOptions.length > 0
              ? selectedOptions.map(option => option.label).join(', ')
              : placeholder}
          </span>
        </section>
        <CaretDownIcon className='w-4 h-4' />
      </div>

      {isOpen && (
        <ul className='absolute left-0 mt-2 w-full bg-[#047401] border border-[#E5E7EB] rounded-md shadow-md max-h-60 overflow-y-auto z-10'>
          {options.map(option => (
            <li
              key={option.value}
              onClick={() => handleOptionClick(option)}
              className='flex items-center gap-2 px-4 py-2  cursor-pointer'
            >
              {option.icon && (
                <span className='w-4 h-4 flex items-center'>{option.icon}</span>
              )}
              <span className='text-sm text-white'>{option.label}</span>
              {selectedOptions.some(
                selected => selected.value === option.value
              ) && <CheckIcon className='w-4 h-4 text-success-50' />}
            </li>
          ))}
        </ul>
      )}
      {error && (
        <span className='text-xs text-destructive-60 mt-1'>{error}</span>
      )}
    </div>
  );
}
